import React from 'react'
import { DatePicker, Typography } from 'antd'
import { FieldError } from 'react-hook-form'
import ErrorText from 'src/app/shared/components/common/error-text'
import './index.scss'
import dayjs from 'dayjs'
import { RangePickerProps } from 'antd/es/date-picker'
import { ArrowRightIcon, CalendarCustomIcon } from 'src/assets/icons'
import { useTranslation } from 'react-i18next'
import { FORMAT_DATE } from 'src/app/shared/constants/app.constants'
import { useSelector } from 'react-redux'
import { getDefaultTimeZone } from 'src/app/store/masterSetup'
import { getUserProfile } from 'src/app/store/auth'
import { colorPrimary } from 'src/app/themes/primaryThemeDefault'

const CustomRangePicker: React.FC<
  Omit<RangePickerProps, 'value'> & {
    label?: string
    required?: boolean
    error?: FieldError
    value?: any
    containerStyle?: React.CSSProperties
  }
> = (props) => {
  const { t } = useTranslation()
  const defaultTimeZone = useSelector(getDefaultTimeZone)
  const userProfile = useSelector(getUserProfile)
  const {
    label,
    required,
    size = 'large',
    error,
    style,
    containerStyle,
    separator = <ArrowRightIcon />,
    suffixIcon = <CalendarCustomIcon />,
    inputReadOnly = true,
    placeholder = [t('AllTransactions:placeholder.from'), t('AllTransactions:placeholder.to')],
    ...etc
  } = props

  const customDateRender = (current: dayjs.Dayjs) => {
    // in case Bank User todayDate base on ternent timezone
    // in case Client User todayDate base on client timezone
    const todayDate = dayjs().tz(userProfile?.client?.timeZoneId ?? defaultTimeZone?.code)

    return (
      <div
        className='ant-picker-cell-inner'
        style={
          current.format('DD/MM/YYYY') == todayDate.format('DD/MM/YYYY')
            ? { border: `1px solid ${colorPrimary}`, borderRadius: '4px' }
            : {}
        }
      >
        {current.date()}
      </div>
    )
  }

  return (
    <div
      className='custom-date-picker'
      style={{
        flex: 1,
        display: 'block',
        ...containerStyle,
      }}
    >
      <Typography
        style={{ textAlign: 'left', fontSize: '14px', fontWeight: 700 }}
        className={`${required ? 'required' : ''} custom-select-label`}
      >
        {label}
      </Typography>
      <DatePicker.RangePicker
        size={size}
        style={{
          marginBottom: error ? 4 : 0,
          marginTop: 4,
          borderRadius: 12,
          width: '100%',
          ...style,
        }}
        status={!!error ? 'error' : ''}
        separator={separator}
        suffixIcon={suffixIcon}
        placeholder={placeholder}
        format={FORMAT_DATE}
        inputReadOnly={inputReadOnly}
        dateRender={customDateRender}
        {...etc}
      />
      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomRangePicker
